import { t } from 'i18next'

import {
    ReasonCancelOrder,
    StatusOrder,
    StepOrderCreate,
} from 'app/types/operations/order'

/** Search params used in the order page. */
export const searchParametersOrder = {
    CLIENTS: 'clients',
    MANAGERS: 'managers',
    SITES: 'sites',
    STATUS: 'status',
}

/** Search params used in the order API. */
export const searchParametersOrderApi = {
    CLIENTS: 'site__customer_name__id__in',
    MANAGERS: 'site__customer_name__client__id__in',
    SITES: 'site__id__in',
    STATUS: 'status',
}

/** Translation key for the status of the order. */
export const statusOrderTranslated: () => Record<StatusOrder, string> = () => ({
    CANCELLED: t('cancelledFeminine'),
    EXPIRED: t('expiredFeminine'),
    IN_PREPARATION: t('inPreparation'),
    ON_DELIVERY: t('onDelivery'),
    READY: t('readyFeminine'),
    REMOVED: t('removedFeminine'),
    RETRIEVED: t('retrievedFeminine'),
    RETRIEVED_BY_SOMEONE_ELSE: t('retrievedBySomeoneElse'),
})

/** Translation key for reason of the order cancellation. */
export const reasonOrderCancellationTranslated: () => Record<
    ReasonCancelOrder,
    string
> = () => ({
    KONVIVE: 'Konvive',
    OTHER: t('other'),
    STOCK: t('stock'),
})

/** Translation key of the step order on creation. */
export const stepOrderCreateTranslated: () => Record<
    StepOrderCreate,
    string
> = () => ({
    KONVIVE: 'Konvive',
    PRODUCTS: t('products'),
    SITE: t('site'),
})
